module.exports = __webpack_public_path__ + "static/media/u36_4.fd0b2b8a.mp3";